var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_18755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 45C35.4263 45 45.4999 34.9264 45.4999 22.5C45.4999 10.0736 35.4263 0 22.9999 0C10.5735 0 0.499878 10.0736 0.499878 22.5C0.499878 34.9264 10.5735 45 22.9999 45Z",
    fill: "#FF6741"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8636_18755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 26.5623C35.4999 23.6457 33.9374 21.354 31.6457 20.2082C32.6874 19.1665 33.4165 17.8123 33.4165 16.2498C33.4165 13.3332 31.1249 11.0415 28.2082 11.0415C26.0207 11.0415 24.2499 12.2915 23.4165 14.1665C23.3124 14.1665 23.104 14.1665 22.9999 14.1665C22.8957 14.1665 22.6874 14.1665 22.5832 14.1665C21.7499 12.2915 19.979 11.0415 17.7915 11.0415C14.8749 11.0415 12.5832 13.3332 12.5832 16.2498C12.5832 17.8123 13.3124 19.1665 14.354 20.2082C12.0624 21.354 10.4999 23.7498 10.4999 26.5623V30.8332H15.7082V33.9582H30.2915V30.8332H35.4999V26.5623ZM28.2082 13.1248C29.979 13.1248 31.3332 14.479 31.3332 16.2498C31.3332 17.9165 29.979 19.3748 28.2082 19.3748C28.2082 17.3957 27.0624 15.729 25.3957 14.7915C25.9165 13.7498 26.9582 13.1248 28.2082 13.1248ZM26.1249 19.3748C26.1249 21.1457 24.7707 22.4998 22.9999 22.4998C21.229 22.4998 19.8749 21.1457 19.8749 19.3748C19.8749 17.604 21.229 16.2498 22.9999 16.2498C24.7707 16.2498 26.1249 17.604 26.1249 19.3748ZM17.7915 13.1248C19.0415 13.1248 20.0832 13.7498 20.604 14.7915C18.9374 15.729 17.7915 17.3957 17.7915 19.3748C16.0207 19.3748 14.6665 18.0207 14.6665 16.2498C14.6665 14.479 16.0207 13.1248 17.7915 13.1248ZM15.8124 28.7498H12.5832V26.5623C12.5832 23.6457 14.7707 21.4582 17.7915 21.4582C17.8957 21.4582 17.9999 21.4582 18.104 21.4582C18.4165 22.1873 18.9374 22.8123 19.4582 23.3332C17.479 24.3748 16.1249 26.354 15.8124 28.7498ZM28.2082 31.8748H17.7915V29.6873C17.7915 26.7707 20.0832 24.5832 22.9999 24.5832C26.0207 24.5832 28.2082 26.7707 28.2082 29.6873V31.8748ZM33.4165 28.7498H30.1874C29.8749 26.354 28.4165 24.3748 26.3332 23.3332C26.9582 22.8123 27.3749 22.1873 27.6874 21.4582C27.7915 21.4582 27.8957 21.4582 28.104 21.4582C31.1249 21.4582 33.3124 23.6457 33.3124 26.5623V28.7498H33.4165Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_18755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.499878)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8636_18755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(10.4999 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialApp);
export default __webpack_public_path__ + "static/media/icon_social_app.90603932114b63e0134a4cdf8f4f2abf.svg";
export { ForwardRef as ReactComponent };